



















  










    






    
































      




















    












    




    






      





































    





      










      








      













    



      





      








      











    


      





















      































    

    


    



      

















      






      







      





      



      



      



      

      





    



      










      


    

    




    








        











              















































































































































































































import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/Auth';
import './MyOrdersPage.css';

function MyOrdersPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [dealerName, setDealerName] = useState('');
  const [processing, setProcessing] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [printing, setPrinting] = useState(false);
  
  
  const [showExternalNumberDialog, setShowExternalNumberDialog] = useState(false);
  const [externalOrderNumber, setExternalOrderNumber] = useState('');
  const [orderForDownload, setOrderForDownload] = useState(null);

  const API_BASE_URL = 'https://test2.planfix-to-syrve.com';

  
  const getCleanUserId = useCallback(() => {
    let cleanUserId = null;
    
    if (user?.user_id) {
      cleanUserId = user.user_id.toString().split(':')[0];
    } else {
      const storedUserId = localStorage.getItem('userId')?.toString() || '271';
      cleanUserId = storedUserId.split(':')[0];
    }
    
    return cleanUserId;
  }, [user]);

  
  const fetchUserData = useCallback(async (userId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/current-user/${userId}`);
      if (response?.data) {
        if (response.data.contractorName) {
          setDealerName(response.data.contractorName);
        } else {
          setDealerName(response.data.username || 'Дилер');
        }
      }
    } catch (error) {
      console.error('Помилка завантаження даних користувача:', error);
    }
  }, [API_BASE_URL]);

  
  const fetchUserOrders = useCallback(async (userId) => {
    if (!userId) {
      console.log('fetchUserOrders: userId не вказано');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log('fetchUserOrders: Запит для userId:', userId);
      const response = await axios.get(`${API_BASE_URL}/api/user-orders/${userId}`);
      console.log('fetchUserOrders: Відповідь:', response.data);
      
      if (response.data.success) {
        setOrders(response.data.data || []);
        console.log(`Отримано ${response.data.data?.length || 0} замовлень`);
      } else {
        console.error('Помилка отримання замовлень:', response.data.error);
        setOrders([]);
      }
    } catch (error) {
      console.error('Помилка завантаження замовлень:', error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }, [API_BASE_URL]);

  
  useEffect(() => {
    const cleanUserId = getCleanUserId();
    console.log('MyOrdersPage: Отриманий userId:', cleanUserId);
    setUserId(cleanUserId);
    
    if (cleanUserId) {
      fetchUserData(cleanUserId);
      fetchUserOrders(cleanUserId);
    } else {
      setLoading(false);
    }
  }, [getCleanUserId, fetchUserData, fetchUserOrders]);

  const getNextOrderNumber = (existingOrders) => {
    if (!existingOrders || existingOrders.length === 0) {
      return 1;
    }
    
    const maxNumber = Math.max(...existingOrders.map(order => {
      const match = order.orderNumber?.match(/ЗАМ-(\d+)/);
      return match ? parseInt(match[1]) : 0;
    }));
    
    return maxNumber + 1;
  };

  const recalculateItemPrice = async (item) => {
    try {
      const heightInMeters = parseFloat(item.height) / 100;
      
      const response = await axios.post(`${API_BASE_URL}/api/calculate-price`, {
        systemName: item.systemName,
        height: heightInMeters,
        width: parseInt(item.width),
        quality: item.fabricQuality,
        color: item.fabricColor,
        userId: userId,
        fabricCode: item.fabricCode
      });

      const data = response.data;

      if (data.success) {
        return {
          ...item,
          price: data.data.basePrice,
          sum: data.data.finalPrice * item.quantity,
          priceCalculation: data.data
        };
      }
      return item;
    } catch (error) {
      console.error('Помилка перерахунку ціни:', error);
      return item;
    }
  };

  
  const handleDownloadExcelClick = (order) => {
    setOrderForDownload(order);
    setExternalOrderNumber(order.externalOrderNumber || '');
    setShowExternalNumberDialog(true);
  };

  
  const downloadOrderExcelWithExternalNumber = async () => {
    if (downloading || !orderForDownload) return;
    
    try {
      setDownloading(true);
      setShowExternalNumberDialog(false);
      console.log('Завантаження Excel файлів для замовлення:', orderForDownload.orderNumber);
      console.log('Зовнішній номер:', externalOrderNumber);
      
      const response = await axios({
        method: 'POST',
        url: `${API_BASE_URL}/api/download-order-excel-with-number`,
        data: {
          userId: orderForDownload.userId || userId,
          orderId: orderForDownload.id,
          externalOrderNumber: externalOrderNumber.trim() || ''
        },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${orderForDownload.orderNumber}_${orderForDownload.dealer || 'order'}_files.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      console.log('Файли успішно завантажено');
    } catch (error) {
      console.error('Помилка завантаження Excel файлів:', error);
      alert('Помилка при завантаженні файлів. Спробуйте пізніше.');
    } finally {
      setDownloading(false);
      setOrderForDownload(null);
    }
  };

  
  const printOrderPDF = async (order) => {
    if (printing || !order) return;
    
    try {
      setPrinting(true);
      console.log('Генерація PDF для замовлення:', order.orderNumber);
      
      const response = await axios({
        method: 'GET',
        url: `${API_BASE_URL}/api/generate-order-pdf/${order.userId || userId}/${order.id}`,
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${order.orderNumber}_${order.dealer || 'order'}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      console.log('PDF успішно згенеровано та завантажено');
    } catch (error) {
      console.error('Помилка генерації PDF:', error);
      alert('Помилка при генерації PDF. Спробуйте пізніше.');
    } finally {
      setPrinting(false);
    }
  };

  const repeatOrder = async (order) => {
    if (processing || !order) return;
    
    try {
      setProcessing(true);
      
      const recalculatedItems = [];
      for (const item of order.items) {
        const recalculatedItem = await recalculateItemPrice(item);
        recalculatedItems.push(recalculatedItem);
      }

      const nextNumber = getNextOrderNumber(orders);
      const newOrderNumber = `ЗАМ-${nextNumber.toString().padStart(3, '0')}`;

      const newOrder = {
        id: null,
        dealer: dealerName || order.dealer,
        orderNumber: newOrderNumber,
        date: new Date().toISOString().split('T')[0],
        items: recalculatedItems,
        notes: `Повтор замовлення ${order.orderNumber} від ${new Date(order.date).toLocaleDateString('uk-UA')}\n\n${order.notes || ''}`,
        status: 'draft',
        userId: userId
      };

      const response = await axios.post(`${API_BASE_URL}/api/save-order`, newOrder);
      
      if (response.data.success) {
        alert(`Створено нове замовлення ${newOrderNumber} на основі ${order.orderNumber} з актуальними цінами`);
        await fetchUserOrders(userId);
      } else {
        alert('Помилка при створенні повторного замовлення: ' + response.data.error);
      }
    } catch (error) {
      console.error('Помилка при повторенні замовлення:', error);
      alert('Помилка при створенні повторного замовлення');
    } finally {
      setProcessing(false);
    }
  };

  const viewOrder = (order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const closeOrderDetails = () => {
    setShowOrderDetails(false);
    setSelectedOrder(null);
  };

  const goToNewOrder = () => {
    navigate('/order');
  };

  
  const getOrderDetailsMessage = (order) => {
    if (!order) return 'Немає даних про замовлення';
    
    const lines = [];
    
    lines.push(`Замовлення №${order.orderNumber}`);
    lines.push('');
    
    order.items.forEach((item, index) => {
      let accessoriesTotal = 0;
      let accessoriesDetails = [];
      
      if (item.add && Array.isArray(item.add) && item.add.length > 0) {
        for (let idx = 0; idx < item.add.length; idx++) {
          const acc = item.add[idx];
          const accQuantity = parseInt(acc.amountadd) || parseInt(acc.quantity) || 1;
          const accPrice = parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0;
          const accSum = accPrice * accQuantity;
          accessoriesTotal += accSum;
          accessoriesDetails.push({
            name: acc.name_add || acc.name,
            quantity: accQuantity,
            sum: accSum,
            price: accPrice
          });
        }
      } else if (item.accessoriesTotal) {
        accessoriesTotal = item.accessoriesTotal;
      }
      
      const systemBasePrice = item.basePrice || item.price || 0;
      const systemFinalPrice = item.finalPrice || item.price || 0;
      const systemFinalSum = systemFinalPrice * item.quantity;
      const totalBeforeDiscount = (systemBasePrice * item.quantity) + accessoriesTotal;
      const totalFinalSum = systemFinalSum + accessoriesTotal;
      const discountAmount = totalBeforeDiscount - totalFinalSum;
      
      lines.push(`Позиція #${index + 1}:`);
      lines.push(`  Система: ${item.systemName}${item.fabricColor ? `, ${item.fabricColor}` : ''}`);
      lines.push(`  Код тканини: ${item.fabricCode || '-'}`);
      lines.push(`  Розміри: ${item.width} x ${item.height} см`);
      lines.push(`  Кількість: ${item.quantity} шт.`);
      lines.push(`  Сторона управління: ${item.controlSide === 'left' ? 'Ліва' : item.controlSide === 'right' ? 'Права' : '-'}`);
      lines.push(`  Ціна за од.: ${systemBasePrice.toFixed(2)} €`);
      
      let accessoryCounter = 1;
      for (const acc of accessoriesDetails) {
        lines.push(`  Додаток ${accessoryCounter}: ${acc.name} - ${acc.sum.toFixed(2)} €`);
        accessoryCounter++;
      }
      
      if (accessoriesTotal > 0) {
        lines.push(`  Вартість дод.: ${accessoriesTotal.toFixed(2)} €`);
      }
      
      if (accessoriesTotal > 0 || discountAmount > 0) {
        lines.push(`  Сума без знижки: ${totalBeforeDiscount.toFixed(2)} €`);
      }
      
      if (discountAmount > 0) {
        lines.push(`  Знижка: -${discountAmount.toFixed(2)} €`);
      }
      
      lines.push(`  Сума зі знижкою: ${totalFinalSum.toFixed(2)} €`);
      
      if (item.itemNotes) {
        lines.push(`  Примітки: ${item.itemNotes}`);
      }
      lines.push('');
    });
    
    const totalSum = order.items.reduce((sum, item) => {
      const systemFinalPrice = item.finalPrice || item.price || 0;
      const systemFinalSum = systemFinalPrice * item.quantity;
      
      let accessoriesSum = 0;
      if (item.add && Array.isArray(item.add) && item.add.length > 0) {
        for (const acc of item.add) {
          const accQuantity = parseInt(acc.amountadd) || parseInt(acc.quantity) || 1;
          const accPrice = parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0;
          accessoriesSum += accPrice * accQuantity;
        }
      } else if (item.accessoriesTotal) {
        accessoriesSum = item.accessoriesTotal;
      }
      
      return sum + systemFinalSum + accessoriesSum;
    }, 0);
    
    lines.push(`Загальна сума замовлення: ${totalSum.toFixed(2)} €`);
    
    if (order.notes) {
      lines.push('');
      lines.push(`Примітки до замовлення: ${order.notes}`);
    }
    
    return lines.join('\n');
  };

  return (
    <div className="my-orders-page">
      <div className="orders-list-modal">
        <h2>Мої замовлення</h2>

        
        {loading ? (
          <p className="no-orders">Завантаження замовлень...</p>
        ) : orders.length === 0 ? (
          <p className="no-orders">У вас ще немає збережених замовлень</p>
        ) : (
          <div className="orders-grid">
            {orders.map(order => {
              const orderSum = order.items?.reduce((sum, item) => {
                const price = item.finalPrice || item.price || 0;
                return sum + (price * item.quantity);
              }, 0) || 0;
              
              return (
                <div key={order.id || order.orderNumber} className={`order-card ${order.status || 'draft'}`}>
                  <div className="order-card-header">
                    <span className="order-number">{order.orderNumber || 'Немає номера'}</span>
                    <span className={`order-status ${order.status || 'draft'}`}>
                      {order.status === 'draft' ? 'Чернетка' : 
                       order.status === 'confirmed' ? 'Підтверджено' : 
                       order.status === 'archived' ? 'Архів' : 'Чернетка'}
                    </span>
                  </div>
                  <div className="order-card-body" style={{ textAlign: 'left' }}>
                    <div>Дата: {order.date ? new Date(order.date).toLocaleDateString('uk-UA') : 'Немає дати'}</div>
<div>Час: {order.time || 'Немає часу'}</div>
                    <div>Дилер: <strong>{order.dealer || 'Не вказано'}</strong></div>
                    <div>Позицій: {order.items?.length || 0}</div>
                    <div>Сума: {orderSum.toFixed(2)} €</div>
                  </div>
                  <div className="order-card-actions">
                    <button onClick={() => viewOrder(order)}>Відкрити</button>
                    <button 
                      onClick={() => printOrderPDF(order)}
                      disabled={printing}
                      className="print-pdf-btn"
                      title="Друк замовлення"
                    >
                      <span role="img" aria-label="print">🖨️</span> 
                      {printing ? '...' : 'Друк'}
                    </button>
                    <button 
                      onClick={() => handleDownloadExcelClick(order)}
                      disabled={downloading}
                      className="download-excel-btn"
                    >
                      <span role="img" aria-label="download">📥</span> 
                      {downloading ? '...' : 'Excel'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {}
      {showExternalNumberDialog && (
        <div className="confirm-dialog-overlay" style={{ zIndex: 1001 }} onClick={() => setShowExternalNumberDialog(false)}>
          <div className="confirm-dialog" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px' }}>
            <div className="confirm-dialog-header">
              <h3>Введіть зовнішній номер замовлення</h3>
              <button className="confirm-dialog-close" onClick={() => setShowExternalNumberDialog(false)}>✕</button>
            </div>
            <div className="confirm-dialog-message" style={{ padding: '20px' }}>
              <p style={{ marginBottom: '10px', color: '#666', fontSize: '14px' }}>
                Введіть зовнішній номер замовлення (можна залишити порожнім)
              </p>
              <input
                type="text"
                value={externalOrderNumber}
                onChange={(e) => setExternalOrderNumber(e.target.value)}
                placeholder="Введіть зовнішній номер..."
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                autoFocus
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    downloadOrderExcelWithExternalNumber();
                  }
                }}
              />
            </div>
            <div className="confirm-dialog-buttons" style={{ padding: '10px 20px 20px' }}>
              <button 
                onClick={() => setShowExternalNumberDialog(false)} 
                className="cancel-btn"
                style={{
                  padding: '8px 20px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Скасувати
              </button>
              <button 
                onClick={downloadOrderExcelWithExternalNumber}
                disabled={downloading}
                className="download-btn"
                style={{
                  padding: '8px 20px',
                  backgroundColor: '#ffc107',
                  color: 'black',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: downloading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  opacity: downloading ? 0.6 : 1
                }}
              >
                {downloading ? 'Завантаження...' : 'Завантажити'}
              </button>
            </div>
          </div>
        </div>
      )}

      {}
      {showOrderDetails && selectedOrder && (
        <div className="confirm-dialog-overlay" onClick={closeOrderDetails} style={{ zIndex: 1000 }}>
          <div className="confirm-dialog" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', maxHeight: '80vh', overflow: 'auto' }}>
            <div className="confirm-dialog-header">
              <h3>Деталі замовлення {selectedOrder.orderNumber}</h3>
              <button className="confirm-dialog-close" onClick={closeOrderDetails}>✕</button>
            </div>
            <div className="confirm-dialog-message" style={{ maxHeight: '50vh', overflow: 'auto' }}>
              {getOrderDetailsMessage(selectedOrder).split('\n').map((line, index) => {
                if (line.trim() === '') return <br key={index} />;
                const colonIndex = line.indexOf(':');
                if (colonIndex > 0 && !line.startsWith('  ')) {
                  const label = line.substring(0, colonIndex + 1);
                  const value = line.substring(colonIndex + 1);
                  return (
                    <div key={index} className="confirm-dialog-line">
                      <span className="confirm-label">{label}</span>
                      <span className="confirm-value">{value}</span>
                    </div>
                  );
                }
                if (line.startsWith('  ')) {
                  const trimmedLine = line.trim();
                  const innerColonIndex = trimmedLine.indexOf(':');
                  if (innerColonIndex > 0) {
                    const label = trimmedLine.substring(0, innerColonIndex + 1);
                    const value = trimmedLine.substring(innerColonIndex + 1);
                    return (
                      <div key={index} className="confirm-dialog-line indented">
                        <span className="confirm-label">{label}</span>
                        <span className="confirm-value">{value}</span>
                      </div>
                    );
                  }
                }
                if (line.startsWith('Позиція #')) {
                  return <div key={index} className="confirm-dialog-line full-width position-title">{line}</div>;
                }
                return <div key={index} className="confirm-dialog-line full-width">{line}</div>;
              })}
            </div>
            <div className="confirm-dialog-buttons" style={{ padding: '15px 20px', display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', borderTop: '1px solid #eee' }}>
              <button 
                onClick={closeOrderDetails} 
                className="cancel-btn"
                style={{
                  padding: '8px 24px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  minWidth: '100px'
                }}
              >
                Закрити
              </button>
              <button 
                onClick={() => printOrderPDF(selectedOrder)}
                disabled={printing}
                className="print-btn"
                style={{
                  padding: '8px 24px',
                  backgroundColor: '#070707',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: printing ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  opacity: printing ? 0.6 : 1,
                  minWidth: '140px'
                }}
              >
                🖨️ {printing ? 'Генерація...' : 'Друк'}
              </button>
              <button 
                onClick={() => handleDownloadExcelClick(selectedOrder)}
                disabled={downloading}
                className="download-btn"
                style={{
                  padding: '8px 24px',
                  backgroundColor: '#ffc107',
                  color: 'Black',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: downloading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  opacity: downloading ? 0.6 : 1,
                  minWidth: '160px'
                }}
              >
                📥 {downloading ? 'Завантаження...' : 'Excel'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MyOrdersPage;
